/** The neutral, single-select filter chips shared with recipe discovery. */
interface FilterChipRowProps {
  options: Array<{ value: string; label: string }>;
  selected: string | null;
  onSelect: (value: string | null) => void;
  ariaLabel?: string;
}

/** Keep All distinct from an option whose actual value is literally "all". */
export function FilterChipRow({ options, selected, onSelect, ariaLabel }: FilterChipRowProps) {
  const chip = (key: string, label: string, value: string | null) => (
    <button
      key={key}
      type="button"
      aria-pressed={selected === value}
      onClick={() => onSelect(value)}
      className={`cursor-pointer rounded-lg px-3 py-1.5 text-sm transition-colors duration-150 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring motion-reduce:transition-none ${
        selected === value
          ? 'bg-foreground text-background'
          : 'bg-muted text-muted-foreground hover:text-foreground'
      }`}
    >
      {label}
    </button>
  );
  return (
    <div role={ariaLabel ? 'group' : undefined} aria-label={ariaLabel} className="flex flex-wrap items-center gap-2">
      {chip('__all__', 'All', null)}
      {options.map(option => chip(`opt-${option.value}`, option.label, option.value))}
    </div>
  );
}
